import { createSelector } from 'reselect'
import { RootState } from 'redux/root-reducer'

const selectYoutubeSubtitle = (state: RootState) => state.youtubeTranscript

export const selectYoutubeTranscript = createSelector(
  [selectYoutubeSubtitle],
  (youtubeCaption) => youtubeCaption.transcript
)
